export const DOCUMENT_LABELS = {
  InitialTranscript: 'Initial Transcript',
  TransferTranscript: 'Transfer Transcript',
  AdditionalTranscript: 'Additional Transcript',
  SeniorCourses: 'Senior Courses',
  MidYearTranscript: 'Mid Year Transcript',
  MidYearReport: 'Mid Year Report',
  FinalTranscript: 'Final Transcript',
  FinalReport: 'Final Report',
  SecondarySchoolReport: 'Secondary School Report',
  SchoolProfile: 'School Profile',
  FERPAWaiver: 'FERPA Waiver',
  FeeWaiver: 'Fee Waiver',
  ACTScoreReport: 'ACT Score Report',
  SATScoreReport: 'SAT Score Report',
  EarlyDecisionContract: 'Early Decision Contract',
  OtherDocuments: 'Other Documents',
  GradeReport: 'Grade Report',
  SATorACT: 'SAT or ACT',
  WithWriting: 'With Writing',
  SubjectTests: 'Subject Tests',
  EssayOrStatement: 'Essay or Statement',
  Resume: 'Resume',
  Portfolio: 'Portfolio',
  Interview: 'Interview',
  AuditionOrPortfolioReview: 'Audition Or Portfolio Review',
  ApplicationProfile: 'Application Profile',
  GenericRecommendation: 'Teacher Recommendation',
  SpecificRecommendation: 'Teacher Recommendation',
  CounselorEvaluation: 'Counselor Recommendation',
  CounselorRecommendation: 'Counselor Recommendation',
  TranscriptInitial: 'Transcript Initial',
  TranscriptMid: 'Transcript Mid',
  TranscriptFinal: 'Transcript Final',
  OtherDocument: 'Other Document',
  OtherRecommendation: 'Other Recommendation',
  CounselorSpecificRecommendation: 'Counselor Recommendation',
  OtherSpecificRecommendation: 'Other Recommendation',
  TranscriptAdditional: 'Transcript Additional',
  TranscriptTransfer: 'Transcript Transfer',
  UniversalFeeWaiver: 'Universal Fee Waiver',
  ProfileAddendum: 'Profile Addendum',
  CollegeTranscript: 'College Transcript',
  HighSchoolTranscript: 'High School Transcript',
  TransferReport: 'Transfer Report',
  MidTermReport: 'Mid-Term Report',
  ApplicationSupplement: 'Application Supplement',
} as const

export type CollegeDocumentType = keyof typeof DOCUMENT_LABELS
